import { Product } from '../types/product.type';
import { UpdateProductRequestDTO } from '../types/dtos/update-product.dto';

export function buildProductUpdatePayload(editedFields: Partial<Product>): UpdateProductRequestDTO {
  const payload: UpdateProductRequestDTO = {};

  if (editedFields.name !== undefined) payload.name = editedFields.name;
  if (editedFields.reference !== undefined) payload.reference = editedFields.reference;
  if (editedFields.description !== undefined) payload.description = editedFields.description;
  if (editedFields.price !== undefined) payload.price = editedFields.price;
  if (editedFields.size !== undefined) payload.size = editedFields.size;
  if (editedFields.origin !== undefined && editedFields.origin !== null) payload.origin = editedFields.origin;
  if (editedFields.stock !== undefined) payload.stock = editedFields.stock;
  if (editedFields.isActive !== undefined) payload.isActive = editedFields.isActive;
  if (editedFields.isTop !== undefined) payload.isTop = editedFields.isTop;
  if (editedFields.isEco !== undefined) payload.isEco = editedFields.isEco;
  if (editedFields.labels !== undefined) payload.labels = editedFields.labels;

  if (editedFields.tax !== undefined) payload.taxId = editedFields.tax.id;
  if (editedFields.subCategory !== undefined) payload.subCategory = editedFields.subCategory.id;
  if (editedFields.tags !== undefined) payload.tags = editedFields.tags.map((tag) => tag.id);
  if (editedFields.weight !== undefined) {
    payload.weight = { quantity: editedFields.weight.quantity, unityId: editedFields.weight.unity.id };
  }

  return payload;
}
